@if (visible) {
  <div class="bv-onboarding-banner" [@fadein]>
    <div class="bv-onboarding-banner__icon">
      <mat-icon>event</mat-icon>
    </div>
    <div class="bv-onboarding-banner__content">
      <span class="bv-onboarding-banner__title">{{ 'ALERTS.ONBOARDING.BANNER_TITLE' | translate }}</span>
      <span class="bv-onboarding-banner__text">{{ 'ALERTS.ONBOARDING.BANNER_TEXT' | translate }}</span>
    </div>
    <div class="bv-onboarding-banner__actions">
      <button type="button" class="bv-btn bv-btn--primary" (click)="onSubscribe()">
        <mat-icon>link</mat-icon>
        {{ 'ALERTS.ONBOARDING.BTN_SUBSCRIBE' | translate }}
      </button>
      <button type="button" class="bv-btn bv-btn--secondary" (click)="onSnooze()">
        {{ 'ALERTS.ONBOARDING.BTN_SNOOZE' | translate }}
      </button>
      <button type="button" class="bv-onboarding-banner__dismiss" (click)="onDismiss()">
        {{ 'ALERTS.ONBOARDING.BTN_DISMISS' | translate }}
      </button>
    </div>
  </div>
}
